module.exports = __webpack_public_path__ + "static/media/token_sale_01.c817570c.png";